import classNames from 'classnames';
import { Heading } from 'yoso';
import { ChallengeTabs } from '~/components/Challenge/Tab/ChallengeTabs';
import { T } from '~/components/I18n';
import { Chevron } from '~/components/Icon/v2/Chevron';
import { Link } from '~/components/Route/Link';
import styles from './ChallengeHeader.module.scss';

export type ChallengeHeaderProps = {
  className?: string;
};

export const ChallengeHeader = ({ className }: ChallengeHeaderProps) => (
  <div className={classNames(styles.root, className)}>
    <Heading level={3} className={styles.title}>
      <T name="citizen_challenge_history_title" />
    </Heading>
    <p className={styles.description}>
      <T name="citizen_challenge_history_desc" />
    </p>
    <p className={styles.description}>
      <T name="citizen_challenge_history_desc2" />{' '}
      <Link
        to="/challenge/leaderboard"
        className={styles.link}
        data-event="click"
        data-event-target="ranking_btn_in_challengehistory">
        <T name="citizen_challenge_history_desc2_link" />
        <Chevron className={styles.chevron} direction="right" />
      </Link>
    </p>
    <ChallengeTabs className={styles.tabs} />
  </div>
);
